import {
    useMemo,
    useState,
} from "react";

import {
    Outlet,
} from "react-router-dom";



import "./UserLayout.css";
import { useCart } from "../context/CartContext";
import UserNavbar from "../user/globalcomponents/UserNavbar/UserNavbar";
import UserSidebar from "../user/globalcomponents/UserSidebar/UserSidebar";

const UserLayout = () => {
    const {
        cartItems,
    } =
        useCart();

    /*
     * IMPORTANT:
     * Sidebar must be OPEN by default.
     *
     * Every fresh page load / browser refresh
     * mounts UserLayout again, so it becomes
     * open again automatically.
     *
     * We are NOT saving this state in
     * localStorage/sessionStorage.
     */
    const [
        sidebarOpen,
        setSidebarOpen,
    ] =
        useState(true);

    const cartCount =
        useMemo(
            () =>
                cartItems.reduce(
                    (
                        total,
                        item
                    ) =>
                        total +
                        item.quantity,
                    0
                ),
            [
                cartItems,
            ]
        );

    const cartTotal =
        useMemo(
            () =>
                cartItems.reduce(
                    (
                        total,
                        item
                    ) =>
                        total +
                        item.finalPrice *
                        item.quantity,
                    0
                ),
            [
                cartItems,
            ]
        );

    /*
     * Navbar menu button should only OPEN.
     *
     * Sidebar already open unte emi jaragadhu.
     * User explicit ga X / backdrop / Escape
     * click chesthey matrame close avuthundhi.
     */
    const openSidebar =
        () => {
            setSidebarOpen(
                true
            );
        };

    const closeSidebar =
        () => {
            setSidebarOpen(
                false
            );
        };

    return (
        <div className="user-layout-shell">
            <UserNavbar
                companyName="SWORLDS SOLUTIONS PVT LTD"
                cartCount={cartCount}
                cartTotal={cartTotal}
                menuOpen={sidebarOpen}
                onMenuClick={openSidebar}
            />

            <UserSidebar
                open={
                    sidebarOpen
                }
                onClose={
                    closeSidebar
                }
            />

            <main
                className={`user-layout-main ${sidebarOpen
                        ? "sidebar-open"
                        : ""
                    }`}
            >
                <div className="user-layout-content">
                    <Outlet />
                </div>
            </main>
        </div>
    );
};

export default UserLayout;